import React, { useEffect } from 'react';

import { Grid, Paper } from '@gogame/components';
import { useMountedState, useProcessAsync } from '@gogame/hooks-ts';
import { useScreenState } from '@gogame/screens';

import DownloadTemplate from 'scenes/BulkUpload/components/DownloadTemplate';
import Message from 'scenes/BulkUpload/components/Message';
import UploadFile from 'scenes/BulkUpload/components/UploadFile';
import { useUpload } from 'scenes/BulkUpload/hooks';

const BulkUpload = () => {
  const [messages, setMessages] = useMountedState([]);
  const [loading, loadingWrapper] = useProcessAsync();

  const screenState = useScreenState();

  const handleMessagesProcess = (messages) => {
    setMessages(messages.reverse());
  };

  const upload = useUpload(loadingWrapper, handleMessagesProcess);
  const handleUpload = async (file) => {
    setMessages([]);
    await upload({ partner: screenState.partner, file });
  };

  useEffect(() => {
    setMessages([]);
  }, [screenState.partner]);

  return (
    <div>
      <Grid container direction={'column'} spacing={2}>
        <Grid item>
          <UploadFile
            onDropFile={handleUpload}
            onChooseFile={handleUpload}
            loading={loading}
          />
        </Grid>
        <Grid item>
          <DownloadTemplate />
        </Grid>
        <Grid item>
          {messages.length ? (
            <Paper variant={'outlined'} style={{ padding: '8px 16px' }}>
              <Grid container direction={'column'}>
                {messages.map(({ type, date, text }, index) => {
                  return (
                    <Grid item>
                      <Message type={type} date={date} key={index}>
                        {text}
                      </Message>
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );
};

export default BulkUpload;
